var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingResource } from "../../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../../constants/IdResource";
import { selectActiveBuildingCostBuff } from "../../../selectors/selectBuffsInfo";
import { utilBuff } from "../../../utils/utilBuff";
import { ButtonDefault } from "../../generic/button-buy/ButtonDefault";
import { ButtonPrimaryMedium } from "../../generic/common/ButtonPrimaryMedium";
import { ButtonSecondaryMedium } from "../../generic/common/ButtonSecondaryMedium";
import { getResourceIcon } from "../../generic/icon/getResourceIcon";
import { TypeNumberRounding } from "../../generic/round-format/TypeNumberRounding";
import { IdTutorialFocusElement } from "../../tutorial/IdTutorialFocusElement";
var ButtonBuyBuildingDOM = /** @class */ (function (_super) {
    __extends(ButtonBuyBuildingDOM, _super);
    function ButtonBuyBuildingDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getPremiumBuilding = function () {
            var _a = _this.props, item = _a.item, buildingInfo = _a.buildingInfo, onBuild = _a.onBuild, premiumCostBuff = _a.premiumCostBuff;
            var stage = item.stage[0];
            if (stage.premium && buildingInfo) {
                var cost = stage.premium.cost[0];
                var resource = selectBalancingResource(cost.resourceId);
                var icon = getResourceIcon(resource);
                var amount = cost.amount;
                var buffedAmount = premiumCostBuff
                    ? utilBuff.applyTo(amount, premiumCostBuff, TypeNumberRounding.Ceil)
                    : undefined;
                return (React.createElement("div", null,
                    React.createElement(ButtonDefault, { onClick: function () { return onBuild(buildingInfo, true); }, component: ButtonSecondaryMedium, amount: amount, buffedAmount: buffedAmount, icon: icon })));
            }
            return undefined;
        };
        _this.getStandardBuilding = function () {
            var _a = _this.props, item = _a.item, buildingInfo = _a.buildingInfo, onBuild = _a.onBuild;
            var stage = item.stage[0];
            if (stage.standard && buildingInfo) {
                var cost = stage.standard.cost[0];
                var resource = selectBalancingResource(cost.resourceId);
                var icon = getResourceIcon(resource);
                return (React.createElement("div", { id: IdTutorialFocusElement.button_building_buy },
                    React.createElement(ButtonDefault, { onClick: function () { return onBuild(buildingInfo, false); }, component: ButtonPrimaryMedium, amount: cost.amount, icon: icon })));
            }
            return undefined;
        };
        return _this;
    }
    ButtonBuyBuildingDOM.prototype.render = function () {
        var premiumBuildingButton = this.getPremiumBuilding();
        var standardBuildingButton = this.getStandardBuilding();
        return (React.createElement("div", { className: "button-ribbon" },
            premiumBuildingButton,
            standardBuildingButton));
    };
    return ButtonBuyBuildingDOM;
}(React.Component));
var mapState = function (state, ownProps) { return ({
    premiumCostBuff: selectActiveBuildingCostBuff(state, ownProps.item.id, IdResource.Gold),
}); };
export var ButtonBuyBuilding = connect(mapState)(ButtonBuyBuildingDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/ButtonBuyBuilding.tsx
// module id = 2736
// module chunks = 3